import errorApi from '../../api/errorApi';
import { getBaseUrl, isEnvelopeEncryptionEnabled } from '../../constants';
import { decrypt, encrypt } from '../../secure';
import { getXApiKeyByEnv } from '../../constants';
import {
  generateSessionKey,
  encryptEnvelope,
  encryptSessionKey,
  isCertificateUsable,
} from '../../secure';
import { debug } from '../../../utils';

export const SESSION_KEY_HEADER = 'uuid_wp';

// export const isEnvelopeEncryptionEnabled = () => {
//   return process.env.REACT_APP_ENVELOPE_ENCRYPTION_ENABLED === 'true';
// };

const withoutLoginDatalake = async ({
  APIPayloadToPost,
  dataLakeEventPayload = null,
}) => {
  // Held for this call only: the response is decrypted with the same key in the
  // closure below. Never stored, logged or shared.
  let sessionKey = null;
  let payloadToPost = APIPayloadToPost;
  const cryptoHeaders = {};

  const useEnvelope =
    isEnvelopeEncryptionEnabled() &&
    !!dataLakeEventPayload &&
    isCertificateUsable();
  if (useEnvelope) {
    try {
      sessionKey = generateSessionKey();
      payloadToPost = {
        ...APIPayloadToPost,
        data: encryptEnvelope(sessionKey, dataLakeEventPayload),
      };
      cryptoHeaders[SESSION_KEY_HEADER] = encryptSessionKey(sessionKey);
    } catch (err) {
      // Any failure here drops back to the legacy body the caller built, so a
      // broken certificate loses events to neither scheme.
      debug(
        'ERROR',
        `[DATALAKE] envelope encryption failed, using legacy`,
        err
      );
      sessionKey = null;
      payloadToPost = APIPayloadToPost;
    }
  }
  // else {
  //   payloadToPost = {
  //     ...APIPayloadToPost,
  //     data: encrypt(null, APIPayloadToPost),
  //   };
  // }

  const res = await errorApi(
    `${getBaseUrl()}dashboardmenus/datalake/default_tracking`,
    payloadToPost,
    'POST',
    { 'x-api-key': getXApiKeyByEnv(), ...cryptoHeaders }
  ).then((res) => {
    const encryptedResponse = res.data.response;
  });
  console.log('datalake response', decrypt(null, res.data.response));
};

export default withoutLoginDatalake;
